import { render } from "./ReportUserByLoginCount.vue?vue&type=template&id=4807b4d8&ts=true"
import script from "./ReportUserByLoginCount.vue?vue&type=script&lang=ts"
export * from "./ReportUserByLoginCount.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ulucefe\\source\\repos\\birimza.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__